import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  public loading = false;
  public error: string;

  constructor(
    public authService: AuthService,
    public router: Router,
  ) {}

  ngOnInit() {
    if (!this.error && history.state?.['error']) {
      this.error = history.state['error'];
    }
  }

  async login() {
    if (this.loading) {
      return;
    }

    try {
      this.error = null;
      this.loading = true;
      await this.authService.login();
    } catch (error) {
      this.error =
        error instanceof Error && error.message ? error.message : 'Login failed';
    } finally {
      this.loading = false;
    }
  }

  async logout() {
    try {
      this.loading = true;
      await this.authService.logout();
    } catch (error) {
      this.error =
        error instanceof Error && error.message ? error.message : 'Logout failed';
    } finally {
      this.loading = false;
    }
  }
}
